// Convert unix epoch to human DateTime
const unixEpochToHumanDateTime = (duration) => {
  const milliseconds = duration * 1000

  const dateObject = new Date(milliseconds)

  return dateObject.toLocaleString()
}

export default {
  unixEpochToHumanDateTime
}